import type { RouteObject } from "react-router-dom";
import { LanguageOutlet } from "@/i18n/language";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import VillasPage from "@/pages/villas/page";
import VillaInfoPage from "@/pages/villa-info/page";
import VillaFrangipaniPage from "@/pages/villa-frangipani/page";
import VillaBougainvilleaPage from "@/pages/villa-bougainvillea/page";
import VillaHibiskusPage from "@/pages/villa-hibiscus/page";
import VillaLocationPage from "@/pages/villa-location/page";
import WeddingsPage from "@/pages/weddings/page";
import ActivitiesPage from "@/pages/activities/page";
import BaliInfoPage from "@/pages/bali-info/page";
import ContactPage from "@/pages/contact/page";
import TourInfoPage from "@/pages/tour-info/page";
import DayTripsPage from "@/pages/day-trips/page";
import MultiDayToursPage from "@/pages/multi-day-tours/page";
import AdventureToursPage from "@/pages/adventure-tours/page";
import DivingCulturePage from "@/pages/tour-diving-culture/page";
import ImpressumPage from "@/pages/impressum/page";
import TourDetailPage from "@/pages/tour-detail/page";
import WeddingDetailPage from "@/pages/wedding-detail/page";
import WeddingInquiryPage from "@/pages/wedding-inquiry/page";
import BaliInfoDetailPage from "@/pages/bali-info-detail/page";
import BookingPage from "@/pages/booking/page";
import BookingMultidayPage from "@/pages/booking-multiday/page";
import BookingRaftingPage from "@/pages/booking-rafting/page";
import BookingSailingPage from "@/pages/booking-sailing/page";
import VillaReservationPage from "@/pages/villa-reservation/page";
import BackstagePage from "@/pages/backstage/page";
import PrivacyPage from "@/pages/privacy/page";
import VoucherPage from "@/pages/voucher/page";
import ShoppingBaliPage from "@/pages/shopping-bali/page";
import HealthSportsPage from "@/pages/health-sports/page";
import AboutPage from "@/pages/about/page";
import NostalgiaPage from "@/pages/nostalgie/page";
import BausteinePage from "@/pages/bausteine/page";
import BausteinePlanungPage from "@/pages/bausteine-planung/page";
import KuebelwagenPage from "@/pages/vw181-kuebelwagen/page";

// Alle Seiten als relative Pfade (ohne führenden "/"), damit sie unter
// "/" (Deutsch) und "/en" (Englisch) identisch funktionieren.
const pageRoutes: RouteObject[] = [
  { path: "villas", element: <VillasPage /> },
  { path: "villa-info", element: <VillaInfoPage /> },
  { path: "villa-frangipani", element: <VillaFrangipaniPage /> },
  { path: "villa-bougainvillea", element: <VillaBougainvilleaPage /> },
  { path: "villa-hibiscus", element: <VillaHibiskusPage /> },
  { path: "villa-location", element: <VillaLocationPage /> },
  { path: "weddings", element: <WeddingsPage /> },
  { path: "weddings/:slug", element: <WeddingDetailPage /> },
  { path: "wedding-inquiry", element: <WeddingInquiryPage /> },
  { path: "activities", element: <ActivitiesPage /> },
  { path: "tour-info", element: <TourInfoPage /> },
  { path: "day-trips", element: <DayTripsPage /> },
  { path: "multi-day-tours", element: <MultiDayToursPage /> },
  { path: "adventure-tours", element: <AdventureToursPage /> },
  { path: "tour/adventure-04", element: <DivingCulturePage /> },
  { path: "tour/:slug", element: <TourDetailPage /> },
  { path: "bali-info", element: <BaliInfoPage /> },
  { path: "bali-info/:slug", element: <BaliInfoDetailPage /> },
  { path: "contact", element: <ContactPage /> },
  { path: "booking", element: <BookingPage /> },
  { path: "booking-multiday", element: <BookingMultidayPage /> },
  { path: "booking-rafting", element: <BookingRaftingPage /> },
  { path: "booking-sailing", element: <BookingSailingPage /> },
  { path: "villa-reservation", element: <VillaReservationPage /> },
  { path: "backstage", element: <BackstagePage /> },
  { path: "privacy", element: <PrivacyPage /> },
  { path: "voucher", element: <VoucherPage /> },
  { path: "shopping-bali", element: <ShoppingBaliPage /> },
  { path: "health-sports", element: <HealthSportsPage /> },
  { path: "impressum", element: <ImpressumPage /> },
  { path: "about", element: <AboutPage /> },
  { path: "nostalgie", element: <NostalgiaPage /> },
  { path: "your-stay", element: <BausteinePage /> },
  { path: "plan-your-stay", element: <BausteinePlanungPage /> },
  { path: "vw181-kuebelwagen", element: <KuebelwagenPage /> },
];

const homeRoute: RouteObject = { index: true, element: <Home /> };

const routes: RouteObject[] = [
  {
    path: "/",
    element: <LanguageOutlet lang="de" />,
    children: [homeRoute, ...pageRoutes],
  },
  {
    path: "/en",
    element: <LanguageOutlet lang="en" />,
    children: [homeRoute, ...pageRoutes],
  },
  { path: "*", element: <NotFound /> },
];

export default routes;